import { Injectable } from '@angular/core';
import { DefaultUrlSerializer, UrlTree } from '@angular/router';

/**
 * Opens an address whose query string arrived encoded as part of the path (bug 40426).
 *
 * Some email tools (HubSpot tracking links) deliver "/?utm_medium=email&..." as "/%3Futm_medium%3Demail&...":
 * the "?" is encoded, so the router reads the tracking parameters as a page path, matches nothing and the visitor
 * got a blank page. When the path holds an encoded "?" and the address has no real one before it, the rest is
 * decoded back into the query string. Every other address parses exactly as before, including a returnUrl whose
 * value carries an encoded "?" (that one follows a real "?").
 */
@Injectable()
export class EncodedQueryUrlSerializer extends DefaultUrlSerializer {

  override parse(url: string): UrlTree {
    return super.parse(EncodedQueryUrlSerializer.restoreQuery(url));
  }

  static restoreQuery(url: string): string {
    if (!url) return url;
    const encoded = url.search(/%3F/i);
    if (encoded === -1) return url;
    const real = url.search(/[?#]/);
    if (real !== -1 && real < encoded) return url;

    const path = url.substring(0, encoded) || '/';
    let rest: string;
    try {
      rest = decodeURIComponent(url.substring(encoded + 3));
    } catch {
      return url;
    }
    return `${path}?${rest}`;
  }
}
